<div class="brands-area wow fadeInUp" data-wow-delay="00ms" data-wow-duration="2500ms">
    <div class="container">
        <div class="section-internal border-bottom pt-75 pb-80">
                            <div class="section-title text-center mb-65">
                    <div class="section-heading-tag">
                        <span class="single-heading-tag bg-royal-blue">Clients</span>
                    </div>
                    <h2>Our partners</h2>
                </div>
            <div class="row align-items-center justify-content-center">
<!--                <div class="col-lg-3">-->
<!--                    <div class="brands-content">-->
<!--                        <div class="brands-section-title">-->
<!--                            <h3><span>5 </span> Institutional Partners</h3>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="col-lg-9">
                    <ngx-slick-carousel [config]="settings" class="brands-slider justify-content-center" id="brands-slider">
                        <!-- Data -->
                        <div class="brands-item" ngxSlickItem *ngFor="let item of partners">
                            <img [src]="item.image" alt="Client">
                        </div>
                        <!-- Data -->
                    </ngx-slick-carousel>
                </div>
            </div> <!-- /.row -->
        </div> <!-- /.section-internal -->
    </div> <!-- /.container -->
</div>
